// Answer Field Appearance ayarlarından cevap textarea'sının inline style'ı.
// Editor ve Visor aynı objeyi kullanır.
export function getInputStyles(state = {}) {
  const radius = `${state.inputBorderRadius ?? 4}px`;
  return {
    backgroundColor: state.inputBackgroundColor || "#ffffff",
    height: `${state.inputHeight || 100}px`,
    fontSize: `${state.inputFontSize || 14}px`,
    fontFamily: state.inputFontFamily || "Arial",
    color: state.inputTextColor || "#000000",
    borderColor: state.inputBorderColor || "#ced4da",
    borderWidth: `${state.inputBorderWidth || 1}px`,
    borderRadius: radius,
    // Global `.form-control { border-radius: 6px !important }` (sass/style.scss) inline
    // borderRadius'u ezer; _freeResponse.scss Corner Roundness'ı bu değişkenden uygular.
    "--fr-input-radius": radius,
    borderStyle: "solid",
    resize: "vertical",
    padding: "8px 12px",
    width: "100%",
  };
}
